import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef, useMemo } from 'react';
import { useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import ActionMenu from '@rexlabs/action-menu';
import { PrimaryIconButton } from '@rexlabs/button';
import ActionMenuSvg from '@rexlabs/icons/action-menu-vertical.svg';
import DatePicker from './date-picker';
var Button = /*#__PURE__*/forwardRef(function Button(props, forwardedRef) {
  var token = useToken();
  var Icon = token('dateInput.predefinedDatePicker.button.icon', ActionMenuSvg);
  return /*#__PURE__*/React.createElement(PrimaryIconButton, _extends({}, props, {
    Icon: Icon,
    ref: forwardedRef
  }));
});

function PredefinedDatePicker(_ref) {
  var _ref$predefinedItems = _ref.predefinedItems,
      predefinedItems = _ref$predefinedItems === void 0 ? [] : _ref$predefinedItems,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["predefinedItems", "onChange"]);

  var token = useToken();
  var spacing = token('dateInput.predefinedDatePicker.spacing', token('spacing.xxs', '.2rem'));
  var items = useMemo(function () {
    return _mapInstanceProperty(predefinedItems).call(predefinedItems, function (item) {
      return {
        label: item.label,
        onClick: function onClick() {
          return onChange === null || onChange === void 0 ? void 0 : onChange({
            target: {
              value: item.value
            }
          });
        }
      };
    });
  }, [predefinedItems, onChange]);
  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    sx: spacing
  }, /*#__PURE__*/React.createElement(DatePicker, _extends({
    onChange: onChange
  }, props)), /*#__PURE__*/React.createElement(ActionMenu, {
    items: items,
    Button: Button
  }));
}

export default PredefinedDatePicker;